import api from '@pray/shared/utils/api';

export async function getArtistYoutubeSummary({ artistId = '' }) {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/socials/youtube`;
  const response = await api.executeGetRequest(url);

  return response.data;
}
